export enum ScrollBarVisibility
{
    auto = "auto",
    hidden = "hidden",
    visible = "scroll"
}